import {
  addMemberToBusinessAccount,
  fetchBusinessAccountMembers,
} from "../api/api";
import { useEffect, useState } from "react";

import { Button } from "@material-tailwind/react";
import Header from "../components/layout/Header";

const Team = () => {
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteStatus, setInviteStatus] = useState("");
  const [members, setMembers] = useState([]);

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await fetchBusinessAccountMembers();
        setMembers(res.members || []);
      } catch (err) {
        console.error("Failed to fetch members", err);
      }
    };

    loadMembers();
  }, []);

  const handleInvite = async () => {
    try {
      if (!inviteEmail) {
        setInviteStatus("Please enter an email address.");
        return;
      }
      await addMemberToBusinessAccount(inviteEmail);
      setInviteStatus(`Invitation sent to ${inviteEmail}`);
      setInviteEmail("");
    } catch (err) {
      setInviteStatus("Failed to send invitation.");
    }
  };

  return (
    <div>
      <Header noconsole />
      <div className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">
          Team Management
        </h1>

        <div className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">Members</h2>
          <div className="border rounded p-4 bg-white shadow">
            <p className="text-gray-500 mb-4">
              Invite a team member to this account.
            </p>
            <input
              type="email"
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              placeholder="Email address"
              className="w-full px-3 py-2 border rounded mb-4 focus:outline-none focus:ring-2 focus:ring-delft-blue"
            />
            <Button onClick={handleInvite} className="bg-delft-blue text-white">
              Invite Member
            </Button>
            {inviteStatus && (
              <p className="text-sm text-gray-600 mt-2">{inviteStatus}</p>
            )}
            {members.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold mb-2">Current Members</h3>
                <ul className="list-disc list-inside text-gray-700">
                  {members.map((member, index) => (
                    <li key={index}>{member}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Access Control
          </h2>
          <div className="border rounded p-4 bg-white shadow">
            <p className="text-gray-500">
              Set granular permissions for team members and dashboards.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
